import angular from "angular";

function userLoggedInHeader() {
  return {
    restrict: 'E',
    scope: {
      controller: '='
    },
    template: require('./templates/user-logged-in-header.html')
  }
}

export default angular.module('directives.userLoggedInHeader', []).directive('userLoggedInHeader', userLoggedInHeader).name;



// WEBPACK FOOTER //
// ./src/app/directives/userLoggedInHeader.js